module.exports = __webpack_public_path__ + "img/slider-7.59714ba2.jpg";